import { persistReducer } from 'redux-persist'
import { Action } from '@reduxjs/toolkit'
import storage from 'redux-persist/lib/storage'

export interface ActionWithPayload<T> extends Action {
  payload?: T
}

export const actionTypes = {
  GetUpdateSqlTableData: '[GetUpdateSqlTableData] Action',
  SetUpdateSqlData: '[SetUpdateSqlData] Action',
  GetUpdateSqlTranslateData: '[GetUpdateSqlTranslateData] Action',
}

const initialUpdateSqlState: IUpdateSqlState = {
  updateSqlColumnList: [],
  updateSqlColumnValues: [],
  updateSqlDefinitions: [],
  updateSqlColumnNames: [],
  updateSqlDataTypes: [],
  updateSqlDe: [],
  updateSqlEn: [],

  updateSqlsOptions: []
}

export interface IUpdateSqlState {
  updateSqlColumnValues: [],
  updateSqlColumnList: [],
  updateSqlDefinitions: []
  updateSqlColumnNames: [],
  updateSqlDataTypes: [],
  updateSqlDe: [],
  updateSqlEn: [],

  updateSqlsOptions: []
}

export const reducer = persistReducer(
  { storage, key: 'portal-UpdateSql', whitelist:  [ ] },
  (state: IUpdateSqlState = initialUpdateSqlState, action: any) => {
    switch (action.type) {
      case actionTypes.GetUpdateSqlTableData: {
        const updateSqlColumnValues = JSON.parse(action.payload.data.scripts);
        let headers = JSON.parse(action.payload.data.headers);
        let updateSqlDefinitions = JSON.parse(action.payload.data.definitions);
        let updateSqlColumnNames = action.payload.data.columnNames;
        let updateSqlDataTypes = action.payload.data.dataTypes;
        let updateSqlColumnList: any = [];
       
        headers.forEach((element: any) => {
          let newElement: any = [...Object.values(element)]
          updateSqlColumnList.push(newElement[0]);
        });
        return { ...state, updateSqlColumnList, updateSqlColumnValues, updateSqlDefinitions, updateSqlDataTypes , updateSqlColumnNames};
      }
    
      case actionTypes.SetUpdateSqlData: {
        const updateSqlColumnValues = action.payload.data;
        return { ...state, updateSqlColumnValues };
      }

      case actionTypes.GetUpdateSqlTranslateData: {
        const updateSqlDe = JSON.parse(action.payload.data.de);
        const updateSqlEn = JSON.parse(action.payload.data.en);
        return { ...state, updateSqlDe, updateSqlEn };
      }
      
      default:
        return state
    }
  }
)

export const actions = {
  getUpdateSqlTableData: (data: any) => ({ type: actionTypes.GetUpdateSqlTableData, payload: { data } }),
  getTranslateData: (data: any) => ({ type: actionTypes.GetUpdateSqlTranslateData, payload: { data } }),
  setUpdateSqlData: (data: any) => ({ type: actionTypes.SetUpdateSqlData, payload: { data } }),
  store: () => ({ type: "def" }),
}

export function* saga() {

}
